var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.94 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.9,34.78q0,5.89,0,11.77c0,2.4-1,3.45-3.46,3.45h-18C26,50,25,49,25,46.49c0-9.87,0-19.74,0-29.61a7.92,7.92,0,0,0-7.91-8,8.19,8.19,0,0,0-1.88.23,8,8,0,0,0-5.75,9.92,7.82,7.82,0,0,0,10.11,5.13c.62-.22,1.23-.49,1.85-.71a1.48,1.48,0,0,1,.46-.09c.46,0,.71.33.8.89a4.54,4.54,0,0,1,0,.74v23.1c0,1.21-.14,1.59-1,1.59a5.86,5.86,0,0,1-.75-.06A23.27,23.27,0,0,1,9.35,44.32c-14.56-11.58-11.57-34.15,5.19-42A24,24,0,0,1,24.81,0C35.6,0,46,7.11,48.89,18.19a35.93,35.93,0,0,1,1,7.25C50,28.55,49.9,31.67,49.9,34.78Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressMeter);
export default __webpack_public_path__ + "static/media/progressMeter.4c8e709da6ced3b89efbbcc929ee32a9.svg";
export { ForwardRef as ReactComponent };